import { StateService } from '@uirouter/angularjs';
import * as angular from 'angular';
import { ngStorage } from 'ngstorage';

// startWith is not supported in IE, opera, safari for now
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function(searchString: string, position: number) {
        position = position || 0;
        return this.lastIndexOf(searchString, position) === position;
    };
}

angular
    .module('app.common')
    .config(['$httpProvider', function($httpProvider: ng.IHttpProvider) {
        $httpProvider.interceptors.push('authInterceptorService');
    }]);

export interface IHttpHeader {
    name: string;
    value: string;
}

class AuthInterceptorService implements ng.IHttpInterceptor {
    public static $inject = ['$q', '$location', '$localStorage', '$timeout', '$state', 'localStorageAuthKey', 'customAuthHeaders'];

    constructor(
        private $q: ng.IQService,
        private $location: ng.ILocationService,
        private $localStorage: ngStorage.StorageService,
        private $timeout: ng.ITimeoutService,
        private $state: StateService,
        private localStorageAuthKey: string,
        private customAuthHeaders: IHttpHeader[]
    ) { }

    public request = (config: ng.IRequestConfig) => {
        // need to compare with constant which comes from server side here

        config.headers = config.headers || {};

        let authKey = this.localStorageAuthKey;
        if (config.params) {
            const url = new URL('http://params?' + config.params);
            const authKeyParam = url.searchParams.get('authKey');
            if (authKeyParam) {
                authKey = authKeyParam;
                config.params = '';
            }
        }
        const authData = this.$localStorage[authKey];

        if (authData) {
            config.headers.Authorization = 'Bearer ' + authData.token;
        }
        if (this.customAuthHeaders && this.customAuthHeaders.length > 0) {
            this.customAuthHeaders.forEach((value) => config.headers[value.name] = value.value);
        }

        return config;
    }

    public responseError = (rejection: ng.IHttpResponse<void>) => {
        if (rejection.status === 401) {
            // need to compare with constant which comes from server side here
            // cannot use account service here due to circular dependencies
            delete this.$localStorage[this.localStorageAuthKey];

            const currentRoute = this.$state.current.name as string;

            if (currentRoute.startsWith('admin')) {
                window.open(this.getReturnUrl('admin.login'), '_self');
            } else if (currentRoute.startsWith('app')) {
                window.open(this.getReturnUrl('account.login'), '_self');
            } else if (currentRoute.startsWith('shopper')) {
                window.open(this.getReturnUrl('shopper.auth.login'), '_self');
            } else {
                this.$timeout(() => window.location.href = '/', 2500);
            }
        }

        // if (rejection.status === 404)
        //     $location.path('/errors/notfound');

        return this.$q.reject(rejection);
    }

    private getReturnUrl(routeName: string) {
        return this.$state.href(routeName, { url: this.$state.href(this.$state.current.name, this.$state.params, {absolute: false}) }, {absolute: false});
    }

}

angular.module('app.common').service('authInterceptorService', AuthInterceptorService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/account/auth-interceptor-base.service.ts